import { PiCaretDown } from "react-icons/pi";
import getFlagEmoji, { getLanguageName } from "./LanguageFlag";

export function LanguageDropdown({
  language,
  excludeLanguage,
  setLanguage,
  ariaLabel,
}: {
  language: string;
  excludeLanguage: string | undefined;
  setLanguage: (value: string) => void;
  // Needed when the dropdown has no visible <label>.
  ariaLabel?: string;
}) {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setLanguage(event.target.value);
  };

  const label = (l: string) => `${getFlagEmoji(l)}  ${getLanguageName(l)}`;

  return (
    <span className="relative inline-flex">
      <select
        value={language}
        onChange={handleChange}
        aria-label={ariaLabel}
        className="h-10 cursor-pointer appearance-none rounded-xl border border-border bg-surface pl-3 pr-9 text-[15px] font-medium text-main-text shadow-card transition-shadow focus:border-primary/60 focus:outline-none focus:ring-4 focus:ring-primary/15"
      >
        {excludeLanguage !== "en" && <option value="en">{label("en")}</option>}
        {excludeLanguage !== "de" && <option value="de">{label("de")}</option>}
        {excludeLanguage !== "ru" && <option value="ru">{label("ru")}</option>}
      </select>
      <PiCaretDown
        size={14}
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-secondary-text"
      />
    </span>
  );
}
